




















































import { Component, Vue } from 'vue-property-decorator'
import { Notify } from '@/helpers/Notify'
import { Helper } from '@/helpers/Helper'
import { Api } from '@/fetch/Api'
import store from '@/store'
import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha'
import { loadScript } from 'vue-plugin-load-script'

@Component({
  components: {
    VueProgrammaticInvisibleGoogleRecaptcha,
  },
})
export default class ResetPassword extends Vue {
  callInProgress = false
  password: string = null
  confirm_password: string = null
  RequestDisabled = true
  // resetToken = $route.params.resetToken
  // console.log(resetToken)

  created() {
    loadScript('https://www.google.com/recaptcha/api.js?render=explicit')
    setTimeout(this.enableLoginButton, 5000)
  }

  public executeCaptcha() {
    (this.$refs.invisibleRecaptcha1 as any).execute()
  }

  public async changePasswordRequest(recaptchaToken) {
    this.callInProgress = true
    try {
      const changePasswordResult = await Api.resetPassword(this.password, this.confirm_password, recaptchaToken, Helper.getCurrentDomain(), this.$route.params.resetToken)
      this.callInProgress = false
      // console.log(changePasswordResult)
      Notify.create({
        type: 'success',
        title: 'Password Updated!',
        text: changePasswordResult.message,
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
    this.$router.push({ path: '/' })
  }

  public enableLoginButton() {
    this.RequestDisabled = false
  }
}
